module.exports = __webpack_public_path__ + "img/driedfruits.93445a65.jpg";